/**
 * Toast Notification System
 * Lightweight, auto-dismissing notifications
 */

let container = null;

function ensureContainer() {
  if (container && document.body.contains(container)) return container;
  container = document.createElement('div');
  container.className = 'toast-container';
  document.body.appendChild(container);
  return container;
}

/**
 * Show a toast notification
 * @param {string} message - Text to display
 * @param {'success' | 'error' | 'info'} [type='info'] - Toast type
 * @param {number} [duration=3000] - Auto-dismiss time in ms
 */
export function showToast(message, type = 'info', duration = 3000) {
  const c = ensureContainer();
  const toast = document.createElement('div');
  toast.className = `toast ${type}`;
  toast.textContent = message;
  c.appendChild(toast);

  setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transform = 'translateY(10px)';
    setTimeout(() => toast.remove(), 200);
  }, duration);
}
